import React, { lazy, Suspense, useCallback, useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { MdOutlineOpenInNew } from "react-icons/md";
import { Button } from "../ui/button.jsx";
import SimuladorEconomia from "./SimuladorEconomia.jsx";

const ModalDefault = lazy(() => import("../ui/modal-default.jsx"));

const LoadingFallback = () => (
  <div className="w-full h-[400px] flex items-center justify-center">
    <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
  </div>
);

const ModalSuccessContent = React.memo(({ onClose, onRedirect }) => (
  <div className="flex flex-col h-[100vh] items-start justify-end md:justify-center">
    <div className="relative flex flex-col items-center justify-center w-[100vw] md:w-[360px] md:h-[310px] bg-white border rounded-t-3xl md:rounded-xl py-10 px-6">
      <button
        className="absolute top-4 right-4 text-black"
        onClick={onClose}
        aria-label="Fechar modal"
      >
        <FaTimes className="w-5 h-5" />
      </button>
      <MdOutlineOpenInNew size={40} color="red" />
      <p className="text-xl text-center font-medium px-4 mt-4 mb-10">
        Você será direcionado para o portal do nosso parceiro.
      </p>
      <Button
        variant="secondary"
        size="lg"
        className="w-full"
        onClick={onRedirect}
      >
        Entendi
      </Button>
    </div>
  </div>
));

const HeroTitle = React.memo(() => (
  <div className="lg:w-[750px] w-full flex flex-col justify-start items-start gap-6 lg:mb-14">
    <div className="w-full flex flex-col justify-center items-start gap-4 py-6 px-10 rounded-[32px] bg-black/40 backdrop-blur-sm hidden md:flex">
      <h1 className="text-white w-full text-left text-4xl lg:text-5xl xl:text-6xl font-thin !leading-tight">
        <strong className="font-bold">
          Energia mais barata em <br className="block md:hidden lg:block" />
          até 3 meses.
        </strong>{" "}
        <br />
        <span className="text-4xl lg:text-5xl">
          Cadastre-se e economize até 15%.
        </span>
      </h1>
    </div>

    {/* Mobile Card Design */}
    <div className="md:hidden w-full px-4 py-4">
      <div className="w-full flex flex-col items-center justify-center gap-2">
        <h1 className="text-white font-bold text-center text-[36px] leading-tight w-full">
          Energia mais barata <br />
          em até 3 meses.
        </h1>
        <p className="text-white text-center text-[36px] leading-tight w-full font-normal">
          Cadastre-se e <br />
          economize até 15%.
        </p>
      </div>
    </div>
  </div>
));

const FirstBlock = () => {
  const [modalState, setModalState] = useState(null);

  const handleCloseModal = useCallback(() => {
    setModalState(null);
  }, []);

  const handleRedirect = useCallback(() => {
    handleCloseModal();
  }, [handleCloseModal]);

  useEffect(() => {
    // Preload o simulador para quando estiver fora do viewport
    const preloadSimulator = setTimeout(() => {
      import("./SimuladorEconomia.jsx");
    }, 1000);

    return () => clearTimeout(preloadSimulator);
  }, []);

  return (
    <div className="w-full hero-gradient bg-cover bg-no-repeat min-h-[85vh]">
      <div className="bg-hero bg-gradient-to-b from-[#FF0000] to-[#D9D9D9] bg-cover bg-no-repeat max-w-[1680px] mx-auto min-h-[85vh]">
        <div className="w-full lg:max-w-[1320px] lg:mx-auto py-14 lg:py-28 flex justify-center items-center px-4 lg:px-8">
          <div className="w-full max-w-[1320px] flex flex-col lg:flex-row justify-end items-center gap-10 px-0 lg:px-0">
            {/* <HeroTitle /> */}
            <Suspense fallback={<LoadingFallback />}>
              <SimuladorEconomia
                onOpenModal={() => setModalState("success")}
              />
            </Suspense>
            {modalState === "success" && (
              <Suspense fallback={null}>
                <ModalDefault isOpen onClose={handleCloseModal}>
                  <ModalSuccessContent
                    onClose={handleCloseModal}
                    onRedirect={handleRedirect}
                  />
                </ModalDefault>
              </Suspense>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstBlock;
